<script setup>

import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";
import BaseModal from "@/components/global-themed/BaseModal.vue";
import ModalHeading from "@/components/seo-score/partials/modals/ui/ModalHeading.vue";
import ModalText from "@/components/seo-score/partials/modals/ui/ModalText.vue";

const emit = defineEmits(['close']);
</script>


<template>
  <Teleport
    to=".tailwind"
  >
    <BaseModal
      modal-class="tw-w-[800px]"
      @close="emit('close')"
    >
      <ModalContentWrapper class="!tw-gap-6">
        <ModalHeading class="tw-text-3xl">
          How your scores are calculated
        </ModalHeading>
        <ModalText>
          Your dashboard shows two scores, each on a scale from 0 to 100:
        </ModalText>

        <hr class="tw-my-4 tw-border-neutral-200">

        <ModalHeading>Website Quality Score</ModalHeading>

        <ModalText>
          This measures how complete your SEO setup is.
          It improves when you:
        </ModalText>

        <ul class="tw-list-disc tw-list-inside tw-ml-4">
          <ModalText as="li">
            Complete recommended actions
          </ModalText>
          <ModalText as="li">
            Fix key issues across your site
          </ModalText>
          <ModalText as="li">
            Assign keywords to the right pages
          </ModalText>
        </ul>

        <ModalText>
          Things to know:
        </ModalText>

        <ul class="tw-list-disc tw-list-inside tw-ml-4">
          <ModalText as="li">
            New opportunities may appear as your site is analyzed
          </ModalText>
          <ModalText as="li">
            These are added gradually to keep your score stable and fair
          </ModalText>
        </ul>

        <hr class="tw-my-4 tw-border-neutral-200">

        <ModalHeading>
          Visibility Score
        </ModalHeading>

        <ModalText>
          This measures how your site is performing in search.
          It is based on a mix of:
        </ModalText>

        <ul class="tw-list-disc tw-list-inside tw-ml-4">
          <ModalText as="li">
            Your tracked keyword rankings
          </ModalText>
          <ModalText as="li">
            Additional keywords your site ranks for
          </ModalText>
          <ModalText as="li">
            Performance trends like traffic and search visibility
          </ModalText>
          <ModalText as="li">
            Data from connected accounts (if available)
          </ModalText>
        </ul>

        <ModalText>
          Things to know:
        </ModalText>

        <ul class="tw-list-disc tw-list-inside tw-ml-4">
          <ModalText as="li">
            The score updates regularly
          </ModalText>
          <ModalText as="li">
            It is designed to be stable, not jump up and down daily
          </ModalText>
        </ul>

        <hr class="tw-my-4 tw-border-neutral-200">

        <ModalHeading>Data connections</ModalHeading>

        <ul class="tw-list-disc tw-list-inside tw-ml-4">
          <ModalText as="li">
            You are not penalized if something is not connected
          </ModalText>
          <ModalText as="li">
            Your score is based only on the data available
          </ModalText>
          <ModalText as="li">
            Connecting more sources gives a more complete view
          </ModalText>
        </ul>

        <hr class="tw-my-4 tw-border-neutral-200">

        <ModalHeading>Tracking your progress</ModalHeading>

        <ul class="tw-list-disc tw-list-inside tw-ml-4">
          <ModalText as="li">
            Your scores are saved over time
          </ModalText>
          <ModalText as="li">
            You can see how your work improves your results
          </ModalText>
          <ModalText as="li">
            Focus on steady progress rather than short-term changes
          </ModalText>
        </ul>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>
